import React from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';

import Breadcrumb from '../Breadcrumb';
import TopMenuAccount from './TopMenuAccount';
import { RootState } from '../../redux/store';
import ThemeSwitch from './Theme';

import './styles.scss';

const TopMenu: React.FC = () => {
  const themeLight = useSelector((state: RootState) => state.app.layoutState.themeLight);

  return (
    <Menu theme={themeLight ? 'light' : 'dark'}>
      <div className="cvta-top-menu__wrapper">
        <Breadcrumb />

        <div className="top-menu__block-right">
          <div className="top-menu__theme-switch">
            <ThemeSwitch />
          </div>
          <TopMenuAccount />
        </div>
      </div>
    </Menu>
  );
};

export default TopMenu;
